import React, {useEffect} from "react";
import ReactSeamlessScroll from "react-seamless-scroll";
import "../style/date.css";

const TablePlay = (props) => {
  const { subData } = props;
  return (
    <tr>
      <td className="rank">
        <p>
          <span>{subData.rank}</span>
        </p>
      </td>
      <td>{subData.company}</td>
      <td>{subData.avgScore}</td>
    </tr>
  );
};

const Broadcast2 = React.memo((props) => {
  const { playData } = props;
  useEffect(()=>{
    console.log(playData);
  })
  return (
    <ReactSeamlessScroll>
      <table className="table-play">
        <tbody>
          {(playData || []).slice(3).map((item) => (
            <TablePlay subData={item} key={item.rank} />
          ))}
        </tbody>
      </table>
    </ReactSeamlessScroll>
  );
});

export default Broadcast2;